import { Product, Settings } from '@/_models/eCommerce/Product';
import { Currency } from '@/_models/Currency';

export enum ESortOption {
  priceDesc,
  priceAsc,
}

export interface IStore {
  products: Product[];
  storeProducts: Product[];
  pageSize: number;
  filterOptions: any;
  tourId: number;
  userId: number;
  productTypes: any;
  rtl: boolean;
  isLoadingProducts: boolean;
  settings: Settings;
  currency: Currency;
  translation: Record<string, string>;
  favoriteProductsIds: number[];
  onChangeFavourite: (product: Product) => void;
  openProduct: (product: Product) => void;
  onClose: () => void;
  setMenuData: (data: any) => void;
  getProductsWithPagination: (options: any) => any;
}
